module.exports = __webpack_public_path__ + "img/N330-2-EN.1fba052d.png";